import { useState, useEffect, useRef } from 'react';

const useChats = (socket, isAuthenticated, userId, chatCategory) => {
  const [chats, setChats] = useState([]);
  const isMounted = useRef(true);  // Mantém o estado de montagem do componente
  const isSameTicketChat = (chat, payload) => {
    const payloadTicket = payload?.TicketNumber || payload?.ticketNumber;
    if (payloadTicket) {
      return chat.chatId === payload.chatId && chat.TicketNumber === payloadTicket;
    }
    return chat.chatId === payload?.chatId;
  };

  useEffect(() => {
    isMounted.current = true;  // Marca como montado

    if (isAuthenticated) {
      const fetchChats = () => {
        const params = {};
        const companyCode = localStorage.getItem('companyCode');
        if (chatCategory === 'meus_chats' && userId) {
          params.userId = userId;
        }
        if (companyCode) {
          params.company_code = companyCode;
        }

        socket.emit('get_chats', params);
      };

      fetchChats();
      const intervalId = setInterval(fetchChats, 5000);

      socket.on('chats', (chatsData) => {
        if (isMounted.current) {
          setChats([...chatsData]);
        }
      });

      socket.on('new_chat', (newChat) => {
        if (isMounted.current) {
          setChats((prevChats) => {
            const chatExists = prevChats.some(
              (chat) => chat.chatId === newChat.chatId && chat.TicketNumber === newChat.TicketNumber
            );
            if (!chatExists) {
              return [...prevChats, { ...newChat, unread: true }];
            }
            return prevChats;
          });
        }
      });

      socket.on('update_chat', (updatedChat) => {
        if (isMounted.current) {
          setChats((prevChats) =>
            prevChats.map((chat) =>
              isSameTicketChat(chat, updatedChat) ? { ...chat, ...updatedChat } : chat
            )
          );
        }
      });

      socket.on('new_message', (message) => {
        if (isMounted.current) {
          setChats((prevChats) =>
            prevChats.map((chat) =>
              isSameTicketChat(chat, message)
                ? { ...chat, lastMessage: message.body, unread: true }
                : chat
            )
          );
        }
      });

      return () => {
        isMounted.current = false;  // Marca como desmontado
        clearInterval(intervalId);
        socket.off('chats');
        socket.off('new_chat');
        socket.off('update_chat');
        socket.off('new_message');
      };
    }
  }, [isAuthenticated, socket, userId, chatCategory]);

  const updateChats = (chat) => {
    if (isMounted.current) {
      setChats((prevChats) => {
        const incomingTicket = chat?.TicketNumber || chat?.ticketNumber;
        const chatExists = prevChats.some(
          (c) =>
            c.chatId === chat.chatId &&
            (!incomingTicket || !c.TicketNumber || c.TicketNumber === incomingTicket)
        );
        if (!chatExists) {
          return [...prevChats, { ...chat, unread: true }];
        } else {
          return prevChats.map((c) =>
            isSameTicketChat(c, chat) ? { ...c, ...chat, unread: true } : c
          );
        }
      });
    }
  };

  const markAsRead = (chatId) => {
    if (isMounted.current) {
      setChats((prevChats) =>
        prevChats.map((chat) =>
          chat.chatId === chatId ? { ...chat, unread: false } : chat
        )
      );
    }
  };

  return { chats, updateChats, markAsRead };
};

export default useChats;
